import LZString from "lz-string";
import { ElNotification } from 'element-plus';
import i18n from "@/plugins/i18n";
import store from '@/store';
import { getloginInfo, postLogout, postBookmarkUpdateStatus } from "@/api";
import { languageEnum, languageIdEnum, countryCodeEnum } from "@/enums/plugins/i18n";
import { ApiReturnCodeEnum } from "@/enums/api";
import { itemTypeEnum } from "@/enums/components/list";

export const memberService = {
    loadLoginInfo: () => {
        getloginInfo().then(data => {
            store.member.mutations.setLoginInfo(data);
        }).catch(error => {
            console.log(error);
        });
    },
    logout: () => {
        postLogout().then(() => {
            window.location.reload();
        }).catch(error => {
            console.log(error);
        });
    },
    getRLloginUrl: () => `${window.rlServerURL.MainWeb}member/#/${languageService.getLanguage()}/login;source=105;rurl=${encodeURIComponent(btoa(encodeURIComponent(window.location.href)))}`,
    getRLsignupUrl: () => `${window.rlServerURL.MainWeb}member/#/${languageService.getLanguage()}/register;source=105;rurl=${encodeURIComponent(btoa(encodeURIComponent(window.location.href)))}`,
}

export const gaService = {
    gaTrackEvent: (type, eventAction, eventLabel, isEventNonInteraction = false) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ 'eventCategory': type, 'eventAction': eventAction, 'eventLabel': eventLabel, 'eventNon-interaction': isEventNonInteraction, 'event': 'GAEvent'});
    },
    gaTrackButtonClick: label => {
        gaService.gaTrackEvent("rl-courses", "button-clicks", label);
    },
    gaTrackBannerClick: label => {
        gaService.gaTrackEvent("rl-courses", "banner-clicks", label);
    },
    recordProductImpression: (item, listName, position) => {
        const data = {
            name: item.title,
            id: item.category[0] + "-" + item.id,
            list: listName,
            brand: "",
            category: item.category.join("/"),
            variant: item.type,
            position: position,
            price: "",
        }
        var dataObj = {
            "event": "ECEvent",
            "eventCategory": "Ecommerce",
            "eventAction": "product list",
            "ecommerce": {
                "impressions": [data]
            }
        };
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(dataObj);
    },
    recordProductClick: (item, listName, position) => {
        const data = {
            name: item.title,
            id: item.category[0] + "-" + item.id,
            brand: "",
            category: item.category.join("/"),
            variant: item.type,
            position: position,
            price: "",
        }
        var dataObj = {
            "event": "ECEvent",
            "eventCategory": "Ecommerce",
            "eventAction": "product click",
            "ecommerce": {
                "click": {
                    "actionField": {"list": listName},
                    "products": [data]
                }
            }
        };
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(dataObj);
    },
    recordProductDetailImpression: (item, listName) => {
        const data = {
            name: item.title,
            id: item.category[0] + "-" + item.id,
            brand: "",
            category: item.category.join("/"),
            variant: item.type,
            price: "",
        }
        var dataObj = {
            "event": "ECEvent",
            "eventCategory": "Ecommerce",
            "eventAction": "product view",
            "ecommerce": {
                "detail": {
                    "actionField": {"list": listName},
                    "products": [data]
                }
            }
        };
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(dataObj);
    }
};

export const languageService = {
    setLanguage: (locale) => {
        if (i18n.mode === "legacy") {
            i18n.global.locale = locale;
        }
        else {
            i18n.global.locale.value = locale;
        }
    },
    getLanguage: () => i18n.global.locale,
    getLocaleMessege: key => i18n.global.getLocaleMessage(i18n.global.locale)[key],
    getLanguagePath: () => i18n.global.locale === languageEnum.EN ? '/' : '/' + i18n.global.locale + '/',
    getLanguageId: () => languageIdEnum[i18n.global.locale.toUpperCase()],
    getTargetLanguagePath: (lang) => {
        const path = window.location.pathname.replace("/" + i18n.global.locale + "/", "/") + window.location.search + window.location.hash;
        if (lang != languageEnum.EN) {
            return "/" + lang + path;
        }
        return path;
    },
    getCountryCode: () => countryCodeEnum[i18n.global.locale.toUpperCase()],
};

export const UtilityService = {
    getDescriptionAndTimecode: youtubeDescription => {
        let removeTimeCodeDescription = youtubeDescription;
        let timecode = [];
        var regex = /(([0-5]?[0-9]:[0-5]?[0-9])|((2[0-3]|[0-1]?[0-9]):[0-5]?[0-9]:[0-5]?[0-9]))(\s|\u200b)+(.+)/g;
        var matches;
        while ((matches = regex.exec(youtubeDescription))) {
            timecode.push({
                text: matches[6],
                time: matches[1],
            });
            removeTimeCodeDescription = removeTimeCodeDescription.replace(matches[0],'');
        }

        return {
            description: removeTimeCodeDescription,
            timecode: timecode
        }
    },
    textToHtml: (text, isTransformLinkToHtml = true) => {
        /* eslint-disable */
        if (!text) {
            return "";
        }
        let result = text;

        if (isTransformLinkToHtml) {
            result = result.replace(/https?:\/\/([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]\S*)/g, match => `<a href="${match}" target="_blank" rel="noreferrer noopener">${match}</a>`)
        }

        return result.replace(/(\n{2,})|(\n)/g, (_match, p1, p2) =>  p1 || p2 ? p1 ? "<br><br>" : "<br>" : "");
    },
    parseAndDecode: data => JSON.parse(LZString.decompressFromUTF16(data)),
    preprocessData: origialItem => {
        if (!origialItem) { 
            return origialItem;
        }

        let item = JSON.parse(JSON.stringify(origialItem));
        const productFamilyNotShowVersion = ["actorcore", "smart gallery", "smart content manager"];
        item.productVersion = item.productVersion || [];
        item.productVersion = item.productVersion.reduce((allVersions, productVersionItem) => {
            if (productFamilyNotShowVersion.includes(productVersionItem.productFamily.toLowerCase())) {
                if (!allVersions.some(version => productVersionItem.productFamily.toLowerCase() == version.productFamily.toLowerCase())) {
                    productVersionItem.version = "";
                    allVersions.push(productVersionItem);
                }
            }
            else {
                allVersions.push(productVersionItem);
            }
            return allVersions;
        }, []);

        const splittedTitle = item.title.split(/ - (.+)/);
        if (splittedTitle.length === 3) {
            item.title = splittedTitle[1]
        }

        if (item.type === itemTypeEnum.SKILL_PATH && item.category.length === 0) {
            item.category = [UtilityService.videoType.skillPath.category];
        } else if (item.category && item.category.length > 0 && item.category[0] === UtilityService.videoType.skillPath.category && !item.type) {
            item.type = itemTypeEnum.SKILL_PATH;
        }
        return item;
    },
    getShowVersion: options => {
        const minimumVersionToShow  = {
            "iclone": 4,
            "cartoon animator": 3,
            "character creator": 1,
            "actorcore": 0,
            "smart gallery": 0
        }
        options.forEach(item => {
            const requireVersion = minimumVersionToShow[item.product.toLowerCase()];
            if (requireVersion != undefined) {
                item.versions = item.versions.filter((version) => {
                    if (requireVersion == 0) {
                        return false;
                    }
                    else {
                        return version >= requireVersion;
                    }
                }).sort((a, b) => b - a);
            }
        });
        return options;
    },
    updateBookmarkStatusProcess: (id, isBookmarked, dataType) => {
        const { getLocaleMessege } = languageService;

        return new Promise((resolve, reject) => {
            postBookmarkUpdateStatus({ id, isBookmarked, dataType }).then(_data => {
                ElNotification({
                    title: '',
                    message: isBookmarked ? 
                        getLocaleMessege("COMMON").UPDATE_BOOKMARK_STATUS_SUCCESS : 
                        getLocaleMessege("COMMON").UPDATE_CANCEL_BOOKMARK_STATUS_SUCCESS,
                    type: 'success',
                    position:'bottom-left',
                })

                resolve();
            }, response => {
                if (response?.data?.apiStatus !== ApiReturnCodeEnum.RESPONSE_INTERCEPT) {
                    ElNotification.error({
                        title: getLocaleMessege("COMMON").API_ERROR_TITLE.replace( /(<([^>]+)>)/ig, ''),
                        message: getLocaleMessege("COMMON").API_ERROR_DESCRIPTION.replace( /(<([^>]+)>)/ig, ''),
                        position:'bottom-left',
                    });

                    reject(`request error, Response = ${response?.status}, ReturnCode = ${response?.data?.apiStatus}`);
                }
                
                reject('response intercept');
            }).catch(error => {
                ElNotification.error({
                    title: getLocaleMessege("COMMON").API_ERROR_TITLE.replace( /(<([^>]+)>)/ig, ''),
                    message: getLocaleMessege("COMMON").API_ERROR_DESCRIPTION.replace( /(<([^>]+)>)/ig, ''),
                    position:'bottom-left',
                });
                
                reject(error);
            })
        })
    },
    videoType: {
        tutorial: {
            category: "home",
            type: "tutorial",
            display: "TUTORIAL",
            apiPath: "v1/Query/Detail",
            value: 1
        },
        master: {
            category: "master-class",
            type: "master",
            display: "MASTER CLASS",
            apiPath: "v1/Query/Detail",
            value: 2
        },
        webinar: {
            category: "webinar",
            type: "webinar",
            display: "WEBINAR",
            apiPath: "v1/Webinar/Detail",
            value: 3
        },
        skillPath: {
            category: "skill-paths",
            type: "skillPath",
            display: "SKILL PATH",
            apiPath: "v1/Query/Detail",
            value: 4
        }
    },
    getVideoType: (category) => {
        const videoType = UtilityService.videoType;
        for (const key in videoType) {
            if (category == videoType[key].category) {
                return videoType[key];
            }
        }
        return null;
    },
    groupVersion: (productVersion) => {
        const group = productVersion.reduce((result, info) => {
            result[info.productFamily] = result[info.productFamily] || [];
    
            if (info.version) {
                result[info.productFamily].push(+info.version);
            }

            return result;
        }, {});
        
        return Object.keys(group).map(productFamily => {
            return {
                productFamily,
                versions: group[productFamily].sort()
            }
        }) 
    },
    sortProduct: (productData, key) => {
        const order = {
            "iClone": 1,
            "Character Creator": 2,
            "Cartoon Animator": 3,
            "AI Studio": 4
        }
        productData.sort((a,b) => {
            const weightA = order[key ? a[key] : a] || 100;
            const weightB = order[key ? b[key] : b] || 100;

            return weightA - weightB;
        })
        return productData;
    },
    formatSeconds: (s) => {
        const formatTime = new Date(s * 1000)
          .toISOString()
          .substr(11, 8)
          .split(":");
        if (formatTime.length >= 3 && formatTime[0] == "00") {
          formatTime.shift();
        }
  
        return formatTime.join(":");
    }
}